import Vue from 'vue'
import VueAxios from 'vue-axios'
import axios from 'axios'
import store from '@/store'

const $axios = axios.create({
    baseURL: `${process.env.API_SERVER}/api/v1`,
})

$axios.interceptors.request.use(config => {
    if (!config.quiet)
        document.getElementsByTagName('body')[0].classList.remove('loaded')
    config.headers.common['Referrer'] = document.referrer
    return config
}, error => Promise.reject(error))

$axios.interceptors.response.use(c => {
        document.getElementsByTagName('body')[0].classList.add('loaded')
        return c
    }, e => {
        document.getElementsByTagName('body')[0].classList.add('loaded')
        // const status = e && e.response && e.response.status ? e.response.status : 600
        return Promise.reject(e)
})

Vue.use(VueAxios, $axios)



// WEBPACK FOOTER //
// ./src/plugins/http.js